export type SituacaoCredito = 'APROVADO' | 'GLOSADO';

export interface ValidacaoCreditoFornecedor {
  chaveAcesso: string;
  cfop: string;
  fornecedor: string;
  cnpj: string;
  valorOperacao: number;
  creditoIBS: number;
  creditoCBS: number;
  dataPgto: string | null;
  status: SituacaoCredito;
}

export const validacoesComiteGestor: ValidacaoCreditoFornecedor[] = [];
